import React, { useState, useEffect } from "react";
import api from "../../api/api";

function OrderAllotSalesOrderToPerson({ setView }) {
  const [users, setUsers] = useState([]); // All users from API
  const [filteredUsers, setFilteredUsers] = useState([]); // For search results
  const [selectedUserId, setSelectedUserId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // ✅ Fetch users on mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const UserName = sessionStorage.getItem("UsrName") || "admin";
        const response = await api.get("GetRmpUserAPI", { User: UserName });

        console.log("GetRmpUserAPI response:", response);

        // normalize response
        const userList = response?.data?.Table || response?.Table || [];

        if (userList.length > 0) {
          setUsers(userList);
          setFilteredUsers(userList);
        } else {
          alert("No users found in response.");
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        alert("Error fetching users.");
      }
    };

    fetchUsers();
  }, []);

  // ✅ Handle search change
  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (value.trim() === "") {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter((user) =>
        user.UserName.toLowerCase().includes(value)
      );
      setFilteredUsers(filtered);
    }
    setIsDropdownOpen(true);
  };

  // ✅ Handle selection
  const handleUserSelect = (user) => {
    setSelectedUserId(user.UserId);
    setSearchTerm(user.UserName);
    setIsDropdownOpen(false);
  };

  // ✅ Allot order API call
  const allotOrder = async () => {
  if (!selectedUserId) {
    alert("Please select a user first.");
    return;
  }

  try {
    const UsrName = sessionStorage.getItem("UsrName") || "admin";
    const Poid = localStorage.getItem("poidContent");   // ✅ comes from handleJobto

    if (!Poid) {
      alert("No order selected. Please go back and select again.");
      return;
    }

    const response = await api.get("AllotOrderToPersonTax", {
      Poid,
      JobTo: selectedUserId,
      Usrname: UsrName,
    });

    const apiData = response?.data || response;
    const result = apiData?.Table?.[0];

    if (result && result.Status) {
      alert(result.Status);
      setView('salesorders'); // ✅ go back after success
    } else {
      alert("Unexpected response from server.");
    }
  } catch (error) {
    console.error("Error allotting order:", error);
    alert("Error allotting order.");
  }
};


  return (
    <div className="w-full p-4">
      <h2 className="mb-4 text-lg font-semibold">Allot Sales Order to Person</h2>

      {/* ✅ Searchable Dropdown */}
      <div className="relative mb-4 sm:col-span-2">
        <label
          htmlFor="user-search"
          className="block text-sm font-medium text-gray-700"
        >
          Select User*
        </label>
        <input
          id="user-search"
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          onFocus={() => {
            setIsDropdownOpen(true);
            if (!searchTerm) setFilteredUsers(users);
          }}
          className="block w-full px-2 py-1 mt-1 border border-gray-300 rounded"
          placeholder="Search user by name"
          autoComplete="off"
        />

        {isDropdownOpen && filteredUsers.length > 0 && (
          <ul className="absolute z-10 w-full mt-1 overflow-y-auto bg-white border rounded shadow max-h-60">
            {filteredUsers.map((user) => (
              <li
                key={user.UserId}
                onClick={() => handleUserSelect(user)}
                className="px-2 py-1 cursor-pointer hover:bg-gray-100"
              >
                <strong>{user.UserName}</strong>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* ✅ Buttons */}
      <div className="flex gap-2">
        <button
          onClick={allotOrder}
          className="px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700"
        >
          Jobto
        </button>

        <button
          onClick={() => setView('salesorders')}
          className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
        >
          Close
        </button>
      </div>
    </div>
  );
}

export default OrderAllotSalesOrderToPerson;
